import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avsFormatNumber',
  standalone: true,
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: number | string, unit?: string) {
    let numberValue = typeof value === 'string'
      ? parseFloat(value)
      : value;

    if (value === undefined || value === null || isNaN(numberValue)) {
      return '';
    }

    const suffixes = Suffixes[unit as keyof typeof Suffixes] ?? Suffixes.default;
    let magnitude = 0;

    while (Math.abs(numberValue) >= 1000 && magnitude < suffixes.length - 1) {
      magnitude += 1;
      numberValue /= 1000;
    }

    const prefix = numberValue < 0 ? '-' : '';
    const postfix = suffixes[magnitude] + (unit?.toUpperCase() ?? '');

    const displayValue = numberValue.toLocaleString('en-US', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    });

    return `${prefix}${displayValue}${unit ? ' ' : ''}${postfix}`;
  }
}

const Suffixes = {
  default: ['', 'k', 'M', 'B', 'T', 'Q'],
  w: ['', 'k', 'M', 'G', 'T', 'Q'],
};
